import React, { useEffect, useRef, useState } from 'react';
import { Box, Fade, Progress, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';

const FakeUploadProgressBar = ({
  isUploading,
  isComplete,
  label,
  onDone
}) => {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(isUploading);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (isUploading) {
      setVisible(true);
      setProgress(3);

      intervalRef.current = setInterval(() => {
        setProgress(current => {
          if (current >= 92) return current;

          let increment;

          if (current < 25) {
            increment = Math.random() * 5;
          } else if (current < 40) {
            increment = Math.random() * 2.5;
          } else if (current < 75) {
            increment = Math.random() * 1.2;
          } else {
            increment = Math.random() * 0.5;
          }

          return Math.min(current + increment, 92);
        });
      }, 350);
    }

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [isUploading]);

  useEffect(() => {
    if (!isComplete) return;

    clearInterval(intervalRef.current);
    setProgress(100);

    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 200);

    const doneTimer = setTimeout(() => {
      onDone?.();
    }, 800);

    return () => {
      clearTimeout(hideTimer);
      clearTimeout(doneTimer);
    };
  }, [isComplete, onDone]);

  if (!visible) return null;

  return (
    <Fade in={visible}>
      <Box
        bg="white"
        borderRadius="lg"
        boxShadow="md"
        p={4}
        width="100%"
      >
        <Text fontSize="sm" fontWeight="600" mb={2}>
          {progress >= 100 ? 'Upload complete' : label}
        </Text>

        <Progress
          borderRadius="full"
          color={colors.primaryScale['600']}
          hasStripe={progress < 100}
          isAnimated={progress < 100}
          size="sm"
          value={progress}
        />

        <Text color="gray.500" fontSize="xs" mt={2}>
          {Math.round(progress)}
          %
        </Text>
      </Box>
    </Fade>
  );
};

FakeUploadProgressBar.propTypes = {
  isUploading: PropTypes.bool.isRequired,
  isComplete: PropTypes.bool.isRequired,
  label: PropTypes.string,
  onDone: PropTypes.func
};

export default FakeUploadProgressBar;
